const { localStorage } = window;

// conf
export const AUTH = 'cache_sys_user_info';
// ..

// fn
export const localSet = (k, v) => {
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch (e) {
    console.warn('local storage set k/v error!', k, v);
  }
};

export const localGet = (k = '') => {
  try {
    return JSON.parse(localStorage.getItem(k));
  } catch (e) {
    return null;
  }
};

export const localClear = (k = '') => {
  localStorage.removeItem(k);
};
